// import { createContext, useContext, useState } from 'react';

// export const CartContext = createContext();

// export const useCart = () => useContext(CartContext);

// export const CartProvider = ({ children }) => {
//   const [cart, setCart] = useState([]);

//   const addToCart = (product, qty = 1) => {
//     setCart(prev => {
//       const existing = prev.find(p => p._id === product._id);
//       const weightPerUnit = product.weightPerUnit || 0;
//       const totalWeight = qty * weightPerUnit;

//       if (existing) {
//         // this line was causing issues 
//         // return prev.map(p => p._id === product._id ? { ...p, qty: p.qty + qty, totalWeight: (p.qty+ qty)* weightPerUnit } : p);

//         const updateQty = existing.qty + qty;
//         const updatedWeight = updateQty * weightPerUnit;
//         return prev.map(p =>
//           p._id === product._id ? { ...p, qty: updateQty, totalWeight: updatedWeight } : p
//         );
//       }
//       return [...prev, { ...product, qty, totalWeight }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCart(prev => prev.filter(p => p._id !== id));
//   };

//   const updateQty = (id, qty) => {
//     setCart(prev =>
//       prev.map(p => p._id === id ? { ...p, qty } : p)
//     );
//   };

//   const clearCart = () => setCart([]);

//   return (
//     <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQty, clearCart }}>
//       {children}
//     </CartContext.Provider>
//   );
// };


// Code updated with weight based costing logic
import { createContext, useContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  // Load cart from localStorage if available, otherwise empty array
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Persist cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, qty = 1) => {
    setCart(prev => {
      const existing = prev.find(p => p._id === product._id);
      if (existing) {
        const newQty = existing.qty + qty;
        return prev.map(p =>
          p._id === product._id ? { ...p, qty: Math.min(newQty, p.stock) } : p
        );
      }
      return [...prev, { ...product, qty }];
    });
  };

  const removeFromCart = (id) => {
    setCart(prev => prev.filter(p => p._id !== id));
  };

  const updateQty = (id, qty) => {
    setCart(prev =>
      prev.map(p =>
        p._id === id ? { ...p, qty: Math.min(qty, p.stock) } : p
      )
    );
  };

  const updateWeight = (id, customWeight) => {
    setCart(prev =>
      prev.map(p =>
        p._id === id ? { ...p, customWeight } : p
      )
    );
  };

  const updateCartItemWeight = (id, weight) => {
    setCart(prev =>
      prev.map(item =>
        item._id === id ? { ...item, customWeight: weight } : item
      )
    );
  };

  const clearCart = () => setCart([]);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQty,
        updateWeight,
        updateCartItemWeight,
        clearCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
